module.exports = __webpack_public_path__ + "static/media/flex_fleet.900d2d0b.png";